import { render, staticRenderFns } from "./BaseLogic.vue?vue&type=template&id=dbb5d59a&"
import script from "./BaseLogic.vue?vue&type=script&lang=js&"
export * from "./BaseLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports